import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Select, Icon } from 'semantic-ui-react';

import _debounce from 'lodash/debounce';
import _isEmpty from 'lodash/isEmpty';

import { FuzzySearch } from 'components/modules/foundation/services/search';

import { DEBOUNCED_SEARCH_QUERY_TIME, MAX_OPTIONS } from './GlobalStyleRuleSearch.constants';
import { createStyleRuleSearchOptions } from './GlobalStyleRuleSearch.utils';
import { StyleRuleConfigurationsPropType } from '../../types/style-rule-configuration';

import './GlobalStyleRuleSearch.scss';

const propTypes = {
  styleRuleConfigurations: StyleRuleConfigurationsPropType.isRequired,
  onSelectStyleRule: PropTypes.func.isRequired,
  onSelectFolder: PropTypes.func.isRequired,
  maxOptions: PropTypes.number,
};

const defaultProps = {
  maxOptions: MAX_OPTIONS,
};

export default function GlobalStyleRuleSearch({
  styleRuleConfigurations,
  onSelectStyleRule,
  onSelectFolder,
  maxOptions,
}) {
  const initialSearchResults = createStyleRuleSearchOptions(styleRuleConfigurations);
  const [searchResults, setSearchResults] = useState(initialSearchResults);
  const [selectedResult, setSelectedResult] = useState(null);
  const [loading, setLoading] = useState(false);

  function addImageToOptions(options) {
    return options.map(({ icon, ...rest }) => ({ ...rest, image: <Icon name={icon} /> }));
  }

  const options = addImageToOptions(searchResults).slice(0, maxOptions);
  const fuzzyInstance = new FuzzySearch(initialSearchResults, ['text'], { shouldSort: false });

  function onSearchQueryChange(e, { searchQuery: nextSearchQuery }) {
    setLoading(true);
    if (!_isEmpty(nextSearchQuery)) {
      setSearchResults(fuzzyInstance.search(nextSearchQuery));
    } else {
      setSearchResults(initialSearchResults);
    }
    setLoading(false);
  }

  function onSelectOption(e, { value }) {
    setSelectedResult(value);
    if (value.includes('@')) {
      onSelectStyleRule(value);
    } else {
      onSelectFolder(value ? value.split('.') : []);
    }
  }

  return (
    <Select
      className="global-style-rule-search"
      placeholder="Search style rules or folders..."
      options={options}
      onChange={onSelectOption}
      value={selectedResult}
      onSearchChange={_debounce(onSearchQueryChange, DEBOUNCED_SEARCH_QUERY_TIME)}
      search={() => options}
      loading={loading}
      selection
      fluid
      clearable
      selectOnNavigation={false}
    />
  );
}

GlobalStyleRuleSearch.propTypes = propTypes;
GlobalStyleRuleSearch.defaultProps = defaultProps;
